module.exports = "https://static.wagwalking.com/_next/static/images/caregiver-avatar-e4852fdcda66ebae9cb4f21208ffb93e.png";